import React from 'react';
import {getMonths, range, getCurrentYear} from '../../../../utils/getters';

const Header = ({
  //@ts-ignore
  date,
  //@ts-ignore
  changeYear,
  //@ts-ignore
  changeMonth,
  //@ts-ignore
  decreaseMonth,
  //@ts-ignore
  increaseMonth,
  //@ts-ignore
  prevMonthButtonDisabled,
  //@ts-ignore
  nextMonthButtonDisabled,
}) => {
  const months = getMonths();
  const years = range(1900, getCurrentYear());
  return (
    <div
      style={{
        margin: 10,
        display: 'flex',
        justifyContent: 'center',
      }}>
      <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
        {'<'}
      </button>
      <select
        value={date.getFullYear()}
        onChange={({target: {value}}) => changeYear(value)}>
        {years.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <select
        value={months[date.getMonth()]}
        onChange={({target: {value}}) => changeMonth(months.indexOf(value))}>
        {months.map(option => (
          <option key={option} value={option}>
            {option}
          </option>
        ))}
      </select>

      <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
        {'>'}
      </button>
    </div>
  );
};

export default Header;
